import * as React from 'react'

const SvgCaretLeftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.875 14.375l-5-4.375 5-4.375v8.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgCaretLeftIcon
